import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import {
    IConfigSerieRadarMultiples,
    RadarMultipleSeriesChart,
} from "../../../../Components/apexcharts/RadarMultipleSeriesChart";
import Expadir from "../../../../Components/Utils/Expandir";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListarusuariosdashboardController } from "../../../../Controllers/Geral/Dashboard/DashboardController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IFiltrouserDashboard } from "../../../../Interfaces/Users/UsersInterface";
import { getXMonthsAgoDate } from "../../../../Tools/DateTools";
import FiltroUsuarioAtendimentoDash from "./FiltroUsuarioAtendimentoDash";
import IndicadoresAtendimento from "./IndicadoresAtendimento";
import { useUserInfor } from "../../../../Context/User";
import { ListarUsuariosGrupoController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";

export default function UsuariosAtendimentos() {
    const { FL_ADMINISTRADOR, MODULOS } = useUserInfor().UserInfor;

    const filtroInicial: IFiltrouserDashboard = {
        DT_ABERTURA_INICIO: getXMonthsAgoDate(1).toISOString().split("T")[0],
    };

    const [filter, setFilter] = useState(filtroInicial);

    const { value: lstAtendimentosDashboard, loading } =
        useAsyncEffect(async () => {
            return ListarusuariosdashboardController(filter ?? {});
        }, [filter]);

    const { value: lstUsuariosDashboard } =
        useAsyncEffect(async () => {
            return ListarUsuariosGrupoController(!FL_ADMINISTRADOR);
        }, [filter]);

    const AtendimentosIndicadores = {
        NR_ATENDIMENTOS_ABERTOS: lstAtendimentosDashboard?.NR_ATENDIMENTOS_ABERTOS,
        NR_ATENDIMENTOS_FECHADOS: lstAtendimentosDashboard?.NR_ATENDIMENTOS_FECHADOS,
        NR_INTERACOES: lstAtendimentosDashboard?.NR_TOTAL_INTERACOES,
        NR_ATENDIMENTOS: lstAtendimentosDashboard?.NR_TOTAL_ATENDIMENTOS
    };

    const arrayTipoPeso = Array<string>();

    const IndicadoresRadarAtendimento = {
        ArrayAbertos: [] as Array<number>,
        ArrayFechados: [] as Array<number>,
    };

    lstAtendimentosDashboard?.ATENDIMENTOS_TIPO_PESO?.forEach((Arres) => {
        arrayTipoPeso.push(Arres.DS_TIPO_PESO_ATENDIMENTO || '');

        IndicadoresRadarAtendimento.ArrayAbertos.push(Arres?.NR_ATENDIMENTOS_ABERTOS || 0);
        IndicadoresRadarAtendimento.ArrayFechados.push(Arres?.NR_ATENDIMENTOS_FECHADOS || 0);
    });

    const AtendimentoRadar: Array<IConfigSerieRadarMultiples> = [
        {
            name: "Fechados",
            data: IndicadoresRadarAtendimento.ArrayFechados,
        },
        {
            name: "Abertos",
            data: IndicadoresRadarAtendimento.ArrayAbertos,
        },
    ];

    return (
        <>
            <IndicadoresAtendimento {...AtendimentosIndicadores} />
            <hr />
            <div className="card card-custom">
                <div className="card-header align-items-center justify-content-center">
                    <div className="text-center flex-grow-1">
                        <div className="text-dark-75 font-weight-bold font-size-h5">
                            Atendimento por Tipo Peso
                        </div>
                    </div>
                </div>
                <div className="card-body justify-content-end">
                    {lstAtendimentosDashboard && (
                        <Expadir hideHR bonusIcon={faFilter} justify={"end"}>
                            <FiltroUsuarioAtendimentoDash
                                Modulos={MODULOS}
                                lstUsuarios={lstUsuariosDashboard || []}
                                handleSubmit={setFilter}
                                default={filtroInicial}
                            />
                        </Expadir>
                    )}

                    <OrSpinner loading={loading} spinner="capys">
                        <RadarMultipleSeriesChart
                            series={AtendimentoRadar}
                            categories={arrayTipoPeso}
                        />
                    </OrSpinner>
                </div>
            </div>
        </>
    );
}
